export enum ComparisonTypeEnum {

    EQUALS,
    NOT_EQUALS,
    CONTAINS,
    GREATER_THAN,
    LESS_THAN,
    IS_NULL,
    IS_NOT_NULL,
}
